
import Axios from "axios";



const Progress = async () => {


    try {
        const response = await Axios.get(`${window.API_URL}/progress.php`);
        
        const progress = response.data.data
        

        return progress;
    } catch (error) {
        console.error("Error fetching progress:", error);
        throw error; 
    }
};



export default Progress;